module.exports = __webpack_public_path__ + "static/img/6Financial-Overview.f36d3a79.gif";